import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { emptyArray } from '../../../../../../utils/arrayUtils';
import { getCodeDisplayLabel, isSbaCertificationExpiringSoon, shouldShowSingleCodeInline } from '../../helpers';

export default function CodesCell({ columnValue, values, onOpen }) {
  if (emptyArray(values)) {
    return <span>Not provided</span>;
  }

  if (shouldShowSingleCodeInline(columnValue, values)) {
    return <span>{getCodeDisplayLabel(values[0])}</span>;
  }

  const hasExpiringSbaCertification =
    columnValue === 'sbaDetails' && values.some((detail) => isSbaCertificationExpiringSoon(detail));

  return (
    <Button
      variant="contained"
      size="small"
      color={hasExpiringSbaCertification ? 'secondary' : 'primary'}
      onClick={() => onOpen(columnValue, values)}
    >
      View All
    </Button>
  );
}

CodesCell.propTypes = {
  columnValue: PropTypes.string.isRequired,
  values: PropTypes.array,
  onOpen: PropTypes.func.isRequired,
};
